module.exports = __webpack_public_path__ + "img/12.aa914bf5.png";